import {SpaGlobalConfig} from '../../generated/core';

export const getClientlibsBaseUrl = (config: SpaGlobalConfig) => {
    const baseUrl = config.integrator ? config.siteUrl : '';
    return `${baseUrl}/etc.clientlibs/clientlibs/vwa-ngw18/ngw18-frontend/apps/resources`;
};
